import { render } from "./project_basic_info.vue?vue&type=template&id=57ff8d42&scoped=true"
import script from "./project_basic_info.vue?vue&type=script&lang=js"
export * from "./project_basic_info.vue?vue&type=script&lang=js"

import "./project_basic_info.vue?vue&type=style&index=0&id=57ff8d42&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ff8d42"]])

export default __exports__